import { render, staticRenderFns } from "./ClosingsDetails.vue?vue&type=template&id=3daa3274"
import script from "./ClosingsDetails.vue?vue&type=script&lang=js"
export * from "./ClosingsDetails.vue?vue&type=script&lang=js"
import style0 from "./ClosingsDetails.vue?vue&type=style&index=0&id=3daa3274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports